"use client";

import { SpeedInsights } from "@vercel/speed-insights/next";
import { useEffect, useState } from "react";

function isDuckDuckGoOniOS(userAgent: string): boolean {
  return /duckduckgo/i.test(userAgent) && /(iphone|ipad|ipod)/i.test(userAgent);
}

export default function ConditionalSpeedInsights() {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    if (["localhost", "127.0.0.1", "[::1]", "::1"].includes(hostname)) return;
    const userAgent = window.navigator.userAgent;
    setShouldRender(!isDuckDuckGoOniOS(userAgent));
  }, []);

  if (!shouldRender) {
    return null;
  }

  return <SpeedInsights />;
}
